<div class="search-container" (keydown.enter)="onEnterPress()">
  <div class="campos-general col-10">
    <!-- Campos -->
    @for (campo of camposVisibles; track campo) { @switch (campo) { @case
    ('ramo') {
    <!-- Ramo -->
    <div class="field-group">
      <label [class.required-field]="camposObligatorios.includes('ramo')"
        >Ramo</label
      >
      <select
        class="input-field"
        [(ngModel)]="selectedLob"
        (change)="onLobChange(+selectedLob)"
      >
        <!-- Si es cotizadores, mostrar solo los ramos 50, 70 y 16 -->
        @if (this.tipo === 'cotizadores') {
        <option value="" hidden>Selecciona</option>
        }
        <!-- Mostrar todos los ramos -->
        @else {
        <option value="">Todos los ramos</option>
        } @for (lob of lobs; track lob.lobId) {
        <option [value]="lob.lobId">
          {{ lob.lobName }}
        </option>
        }
      </select>
    </div>
    } @case ('subramo') {
    <!-- Sub-Ramo-->
    <div class="field-group">
      <label
        class="subramo"
        [class.required-field]="camposObligatorios.includes('subramo')"
        >Sub-Ramo</label
      >
      <select
        [disabled]="filteredSLobs.length === 0"
        class="input-field"
        [(ngModel)]="selectedSLob"
      >
        <!-- Si es cotizadores, mostrar solo los ramos 50, 70 y 16 -->
        @if (this.tipo === 'cotizadores') {
        <option value="" hidden>Selecciona</option>
        }
        <!-- Mostrar todos los subramos -->
        @else {
        <option value="">Todos los subramos</option>
        } @for (sLob of filteredSLobs; track sLob.sLobId) {
        <option [value]="sLob.sLobId">
          {{ sLob.sLobName }}
        </option>
        }
      </select>
    </div>
    } @case ('cliente') {
    <!-- Cliente -->
    <div class="field-group-search">
      <label
        class="pr-1 filtrar-por"
        [class.required-field]="camposObligatorios.includes('cliente')"
        >Filtrar por</label
      >

      <input
        type="text"
        [(ngModel)]="cliente"
        class="input-field"
        placeholder="Identificación"
        (focus)="onFocus()"
        (change)="isPolicyOrEventNumber(clienteInput.value)"
        #clienteInput
      />
      <span class="info-icon info-data" [attr.data-tooltip]="tipo === 'reclamos' ? tooltipMessageReclamos : tooltipMessage">ℹ️</span>
      @if(this.noEncontrado){
      <div class="modal-overlay" [class.closing]="isClosing">
        <div class="modal-content" [class.closing]="isClosing">
          <div class="check-icon">
            <div class="search-animation">
              <div class="magnifier">
                <div class="magnifier-circle"></div>
                <div class="magnifier-bar"></div>
              </div>
            </div>
          </div>
          <h4>Cliente no encontrado</h4>
          <p>
            Por favor, verifica la información del cliente y vuelve a
            intentarlo.
          </p>
          <button class="button-main" (click)="onContinue()">Continuar</button>
        </div>
      </div>
      }
    </div>
    } @case ('tipoDoc') {
    <!-- Tipo de Documento -->
    <div class="field-group">
      <label
        class="documentos-label"
        [class.required-field]="camposObligatorios.includes('tipoDoc')"
        >Documentos</label
      >
      <select
        [(ngModel)]="tipoDoc"
        class="input-field"
        (change)="onTipoDocChange()"
      >
        <option value="" hidden>Selecciona</option>
        @for (tipo of documentTypes; track tipo.documentTypeId;) {
        <option [value]="tipo.documentTypeId">
          {{ tipo.documentTypeName }}
        </option>
        }
      </select>
    </div>
    } @case ('moneda') {
    <!-- Moneda -->
    <div class="field-group">
      <label [class.required-field]="camposObligatorios.includes('moneda')"
        >Moneda</label
      >
      <select [(ngModel)]="moneda" class="input-field">
        <option value="">Seleccione moneda</option>
        @for (currency of currencies; track currency.currencyId) {
        <option [value]="currency.currencyId">
          {{ currency.currencyName }}
        </option>
        }
      </select>
    </div>
    } @case ('onlyPcyWithBalance') {
    <!-- Solo Pólizas con Balance -->
    <div class="field-group">
      <label
        class="balance-label"
        [class.required-field]="
          camposObligatorios.includes('onlyPcyWithBalance')
        "
        >Balance</label
      >
      <input type="checkbox" [(ngModel)]="onlyPcyWithBalance" />
    </div>
    }@case('AllCheck'){
    <div class="field-group">
      <label [class.required-field]="camposObligatorios.includes('AllCheck')"
        >Mostrar todas las polizas</label
      >
      <input type="checkbox" [(ngModel)]="AllCheck" />
    </div>
    }@case ('bolanteDePago'){
    <div class="field-group">
      <label
        class="mr-2"
        [class.required-field]="camposObligatorios.includes('bolanteDePago')"
        >Facturas Saldadas</label
      >
      <input type="checkbox" [(ngModel)]="bolanteDePago" />
    </div>
    }@case ('desde') {
    <!-- Desde -->
    <div class="field-group">
      <label [class.required-field]="isRequiredField('desde')"
        >Desde</label
      >
      <div class="date-input">
        <input
          type="date"
          [(ngModel)]="desde"
          [attr.min]="applyDateRangeLimit ? getMinDate() : null"
          [max]="getMaxDate()"
          (ngModelChange)="onDesdeChange()"
          (keydown.enter)="$event.preventDefault()"
          class="input-field"
          appCustomDatePicker
        />
      </div>
    </div>
    } @case ('hasta') {
    <!-- Hasta -->
    <div class="field-group">
      <label [class.required-field]="isRequiredField('hasta')"
        >Hasta</label
      >
      <div class="date-input">
        <input
          type="date"
          [(ngModel)]="hasta"
          [min]="desde"
          [max]="getMaxDate()"
          (keydown.enter)="$event.preventDefault()"
          (ngModelChange)="onHastaChange()"
          class="input-field"
          appCustomDatePicker
        />
      </div>
    </div>
    } @case ('corte') {
    <!-- Corte -->
    <div class="field-group">
      <label [class.required-field]="camposObligatorios.includes('corte')"
        >Corte</label
      >
      <div class="date-input">
        <input
          type="date"
          [(ngModel)]="corte"
          (keydown.enter)="$event.preventDefault()"
          [max]="getMaxDate()"
          class="input-field"
          appCustomDatePicker
        />
      </div>
    </div>
    } @case ('corteSinestralidad') {
    <!-- Corte -->
    <div class="field-group">
      <label
        [class.required-field]="
          camposObligatorios.includes('corteSinestralidad')
        "
        >Corte</label
      >
      <div class="date-input">
        <input
          type="date"
          [(ngModel)]="corteSinestralidad"
          [max]="getMaxDate()"
          (keydown.enter)="$event.preventDefault()"
          (change)="onCorteSinestralidadChange()"
          class="input-field"
          appCustomDatePicker
        />
      </div>
    </div>
    } @case ('cortePeriodo') {
    <!-- Corte Periodo -->
    <div class="field-group">
      <label
        class="corte-periodo-label"
        [class.required-field]="camposObligatorios.includes('cortePeriodo')"
        >Corte</label
      >
      <div class="corte-periodo-cont">
        <div class="field-group">
          <div class="date-input">
            <input
              type="month"
              class="input-field"
              [(ngModel)]="cortePeriodo"
              (keydown.enter)="$event.preventDefault()"
              appCustomDatePicker
            />
          </div>
        </div>
        <div class="field-group">
          <select
            [(ngModel)]="cortePeriodoOption"
            class="input-field-corte-periodo"
            [disabled]="disableSelectCorte()"
          >
            <option value="" selected hidden>Tipo de corte</option>
            @for (corte of SeleccionCortes; track corte; let i = $index) {
            <option [value]="corte !== 'Corte mensual' ? i + 1 : 3">
              {{ corte }}
            </option>
            }
          </select>
        </div>
      </div>
    </div>
    } @case ('policy') {
    <!-- Descargas -->
    <div class="field-group">
      <label [class.required-field]="camposObligatorios.includes('policy')"
        >Póliza</label
      >
      <input
        type="text"
        [(ngModel)]="policy"
        class="input-field"
        placeholder="No. de póliza"
      />
    </div>
    } @case ('tipoDocumentoIdentificacion') {
    <!-- Tipo de Documento de Identificación -->
    <div class="field-group">
      <label
        class="tipo-documento-label"
        [class.required-field]="
          camposObligatorios.includes('tipoDocumentoIdentificacion')
        "
        >Identificación</label
      >
      <select
        class="input-field"
        [(ngModel)]="tipoDocumentoSeleccionado"
        (change)="resetFields()"
      >
        <option value="0" hidden>Selecciona</option>
        @for (tipo of tiposDocumentoIdentificacion; track tipo.id) {
        <option [value]="tipo.id">{{ tipo.nombre }}</option>
        }
      </select>
    </div>

    <div class="field-group field-group-search">
      <input
        type="text"
        [disabled]="!tipoDocumentoSeleccionado"
        [(ngModel)]="documentoIdentidad"
        class="input-field"
        placeholder="No. de Identificación"
        (keypress)="keypress($event)"
        name="documentoIdentidad"
        (input)="onInputChange($event)"
        (paste)="onInputChange($event)"
        (change)="onInputChange($event)"
        [maxlength]="
          tipoDocumentoSeleccionado === 1
            ? maxLengths.RNC
            : tipoDocumentoSeleccionado === 2
            ? maxLengths.CEDULA
            : tipoDocumentoSeleccionado === 3
            ? maxLengths.PASAPORTE
            : null
        "
      />
      <span class="info-icon-documento info-data">ℹ️</span>
    </div>
    }@case ('selectFilter') {
    <!-- Filtro con select -->
    <div class="field-group">
      <label
        class="select-filter-label"
        [class.required-field]="
          camposObligatorios.includes('selectFilter')
        "
        >Filtrar por</label
      >
      <select
        class="input-field"
        [(ngModel)]="tipoFiltroSeleccionado"
        (change)="resetFields()"
      >
        <option value="" hidden>Selecciona</option>
        @for (tipo of opcionesSelectFilter; track tipo.id) {
        <option [value]="tipo.id">{{ tipo.nombre }}</option>
        }
      </select>
    </div>

    <div class="field-group field-group-search">
      <input
        type="text"
        [disabled]="!tipoFiltroSeleccionado"
        [(ngModel)]="busquedaFiltro"
        class="input-field"
        placeholder="Búsqueda"
        (keypress)="keypress($event)"
        name="busquedaFiltro"
        (input)="onInputFilterChange($event)"
        (paste)="onInputFilterChange($event)"
        (change)="onInputFilterChange($event)"
      />
      <!-- <span class="info-icon-documento info-data">ℹ️</span> -->
    </div>
    } } }
  </div>

  <!-- Botones Acciones-->
  <div class="button-group col-2">
    <!-- Buscar -->
    <button
      class="btn-m-new"
      (click)="buscar()"
      [disabled]="isBuscarDisabled()"
      [ngClass]="{ 'btn-disabled': isBuscarDisabled() }"
    >
      Buscar
    </button>
    <!-- Limpiar -->
    <button class="btn-s-new" (click)="limpiar()">Limpiar</button>
  </div>
</div>
